import React from 'react';

import { useTranslation } from 'react-i18next';
import Search from '../../Framework/Components/Search';
import Text from '../../Framework/Components/Form/TextInput';
import Toggle from '../../Framework/Components/Form/Toggle';
import StaticDropDown from '../../Framework/Components/Form/StaticDropDown';

const ArticleSearch = (props) => {
    const { t } = useTranslation();
    const sortOptions = [
        {
            id: 'published_at',
            label: t('articles.sortby.published_date_oldest'),
        },
        {
            id: '-published_at',
            label: t('articles.sortby.published_date_newest'),
        },
        {
            id: '-created_at',
            label: t('articles.sortby.created_date_oldest'),
        },
        {
            id: 'created_at',
            label: t('articles.sortby.created_date_newest'),
        },
    ];

    return (
        <Search {...props}>
            <Text name="title" />
            <Toggle name="is_active" />
            <StaticDropDown name="sort_by" staticOptions={sortOptions} />
        </Search>
    );
};

export default ArticleSearch;
